import { useTranslation } from 'react-i18next';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { RangePlanningItem } from '../types';

interface UomConversionsTabProps {
  item: RangePlanningItem;
}

const UomConversionsTab = ({ item }: UomConversionsTabProps) => {
  const { t } = useTranslation('rangePlanningItems');

  if (item.uomConversions.length === 0) {
    return (
      <Paper variant="outlined"
        sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {t('noUomConversions', 'No unit of measure conversions recorded for this item.')}
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('fromUom', 'From UOM')}</TableCell>
            <TableCell>{t('toUom', 'To UOM')}</TableCell>
            <TableCell align="right">{t('factor', 'Factor')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {item.uomConversions.map((conversion, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <TableRow key={`${conversion.fromUom}-${conversion.toUom}-${i}`}>
              <TableCell>{conversion.fromUom}</TableCell>
              <TableCell>{conversion.toUom}</TableCell>
              <TableCell align="right">{conversion.factor}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default UomConversionsTab;
